export default __webpack_public_path__ + "static/media/dataQuality.e5a5e17a.svg";